import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetUserDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetUserDto';
import { RoleText, Role } from '../../../common/spdCore/authorization/roles';
import momencik from '../../../common/momencik';

import { UserStampsLink } from './UserStampsLink';

interface UserProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  withFilterInColumns?: boolean;
}

export const userForGrid = (user: GetUserDto) => {
  return {
    key: user.id,
    values: {
      'user.name': user.name,
      'user.email': user.email,
      'user.licenseNumber': user.licenseNumber,
      'user.description': user.description,
      user_admin_yes_no: user.admin ? 'TAK' : 'NIE',
      user_active_yes_no: user.active ? 'TAK' : 'NIE',
      user_role: user.roles
        ? user.roles
            .map(t => RoleText[t as keyof typeof RoleText])
            .filter(Boolean)
            .join(', ')
        : '',
      user_uid_yes_no: user.uid ? 'TAK' : 'NIE',
      'company.name': user?.companiesInUser
        ?.map(c => c.company?.name)
        .filter(Boolean)
        .join(', '),
      user_tfa_yes_no: user.twoFactorEnabled ? 'TAK' : 'NIE',
      user_tfa_last_activity_at: momencik(user.lastTfaActivityAt, 'LLL'),
      'user.lastExamAt': momencik(user.lastExamAt, 'LLL'),
      stamps:
        user.roles &&
        user.roles.some(role =>
          [
            Role.PsychologistAssessor,
            Role.PsychologistSpecialist,
            Role.MedicalAssessor,
            Role.MedicalSpecialist,
            Role.ExternalRegistration,
            Role.Ophthalmologist,
            Role.Neurologist,
            Role.Psychiatrist,
            Role.Laryngologist,
          ].includes(role as Role),
        ) ? (
          <>
            <UserStampsLink userId={user.id} />
          </>
        ) : (
          ''
        ),
    },
    isInactive: !user.active,
  };
};

export const Users: React.FC<UserProps> = props => {
  const columns = [
    { header: 'Imię i nazwisko', property: 'user.name' },
    { header: 'Adres e-mail', property: 'user.email' },
    { header: 'Numer uprawnień', property: 'user.licenseNumber' },
    { header: 'Role', property: 'user_role', noSorting: true },
    { header: 'Opis', property: 'user.description' },
    { header: 'Administrator', property: 'user_admin_yes_no' },
    { header: 'Aktywny', property: 'user_active_yes_no' },
    { header: 'Zarejestrowany', property: 'user_uid_yes_no', noSorting: true },
    { header: 'Firma/filia', property: 'company.name' },
    { header: '2FA', property: 'user_tfa_yes_no' },
    {
      header: 'Ost. akt. 2FA',
      property: 'user_tfa_last_activity_at',
    },
    {
      header: 'Ost. uruch. badania',
      property: 'user.lastExamAt',
    },
    { header: '', property: 'stamps', noFilter: true, noSorting: true },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      withFilterInColumns={props.withFilterInColumns}
      initialOrderColumn="user.name"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak użytkowników w systemie"
      refresh={props.refresh}
      showExport={true}
    />
  );
};
